// @flow
// Importing React as a namespace instead of using the default import to get access to the react types.
// https://flow.org/en/docs/react/types/
import * as React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import {
    red,
    lightBlue,
    green,
} from '@material-ui/core/colors';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '../IconButton';

const AlertVariants = {
    info: 'info',
    success: 'success',
    error: 'error',
};

type AlertData = {
    backgroundColor: ?string,
    icon: ?React.Node,
    textColor: ?string,
}

const getAlertData = (variant: ?string): AlertData => {
    const textColor = '#FFFFFF';
    const iconStyle = {
        color: textColor,
    };

    switch (variant) {
    case AlertVariants.info:
        return {
            backgroundColor: lightBlue[500],
            icon: <InfoIcon style={iconStyle} />,
            textColor,
        };
    case AlertVariants.success:
        return {
            backgroundColor: green[500],
            icon: <CheckCircleIcon style={iconStyle} />,
            textColor,
        };
    case AlertVariants.error:
        return {
            backgroundColor: red[500],
            icon: <WarningIcon style={iconStyle} />,
            textColor,
        };
    default:
        return {
            backgroundColor: null,
            icon: null,
            textColor: null,
        };
    }
};

type Props = {
    title: string,
    icon?: React.Node,
    message?: string,
    variant?: string,
    open?: boolean,
    onClick?: Function,
    onDismiss?: Function,
    maxWidth?: number,
    titleTypographyProps?: {
        variant: string,
        className: string,
    },
    subheaderTypographyProps?: {
        className: string,
    }
}

const Alert = (props: Props) => {
    const alertData = getAlertData(props.variant);

    return (
        props.open &&
        <Card
            onClick={props.onClick}
            style={{
                maxWidth: props.maxWidth,
                marginBottom: 15,
                marginLeft: 'auto',
                marginRight: 'auto',
                backgroundColor: alertData.backgroundColor,
            }}
            elevation={0}
        >
            <CardHeader
                avatar={props.icon || alertData.icon}
                action={
                    <IconButton
                        onClick={props.onDismiss}
                        title="Dismiss"
                    >
                        <CloseIcon
                            style={{
                                color: (props.variant) ? '#FFFFFF' : null,
                            }}
                        />
                    </IconButton>
                }
                title={props.title}
                subheader={props.message}
                titleTypographyProps={{
                    variant: 'title',
                    style: {
                        color: alertData.textColor,
                    },
                    ...props.titleTypographyProps,
                }}
                subheaderTypographyProps={{
                    style: {
                        color: alertData.textColor,
                    },
                    ...props.subheaderTypographyProps,
                }}
            />
        </Card>
    );
};

Alert.defaultProps = {
    title: '',
    message: '',
    icon: null,
    variant: null,
    open: false,
    onClick: () => {},
    onDismiss: () => {},
    titleTypographyProps: {},
    subheaderTypographyProps: {},
};

export default Alert;